/* Diesel PLP/search product-card hover gallery.
   Each card renders up to 8 media images but only the first is loaded on paint;
   the rest carry data-lazysrcset/data-lazysrc and are swapped in the first time
   the card is hovered (mouseover) or an arrow is tapped — so the grid loads one
   image per tile instead of flooding the connection. Also drives the prev/next
   arrows (the --gindex transform). Document-delegated so it works on the
   collection grid, search results, and any re-rendered/paginated sections. */
(function () {
  if (window.__dieselCardGalleryBound) return;
  window.__dieselCardGalleryBound = true;

  function dieselLoadCardImages(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[data-lazysrcset]').forEach(function (img) {
      var srcset = img.getAttribute('data-lazysrcset');
      var src = img.getAttribute('data-lazysrc');
      if (srcset) img.setAttribute('srcset', srcset);
      if (src) img.setAttribute('src', src);
      img.removeAttribute('data-lazysrcset');
      img.removeAttribute('data-lazysrc');
    });
  }

  document.addEventListener('mouseover', function (event) {
    var gallery = event.target.closest && event.target.closest('.diesel-card-gallery');
    if (gallery) dieselLoadCardImages(gallery);
  });

  // Mobile has no hover: load the deferred (2nd+) images the first time the user
  // touches a gallery so the swipe carousel has them ready. Keeps images lazy
  // until interaction (same intent as the desktop hover load).
  document.addEventListener('touchstart', function (event) {
    var gallery = event.target.closest && event.target.closest('.diesel-card-gallery');
    if (gallery) dieselLoadCardImages(gallery);
  }, { passive: true });

  // Mobile: keep the active indicator dot in sync with the scroll-snap carousel.
  // Scroll events don't bubble, so listen in the capture phase.
  document.addEventListener('scroll', function (event) {
    var track = event.target && event.target.closest && event.target.closest('.diesel-gallery__track');
    if (!track) return;
    var gallery = track.closest('.diesel-card-gallery');
    if (!gallery) return;
    var dots = gallery.querySelectorAll('.diesel-gallery__dot');
    if (!dots.length) return;
    /* Direction-aware: raw scrollLeft is negative in RTL, so the old
       Math.round(scrollLeft / width) produced a negative index that clamped
       every dot to the first. See assets/diesel-rtl-scroll.js. */
    var idx = window.DieselScroll.indexFromOffset(track, track.clientWidth, dots.length);
    for (var i = 0; i < dots.length; i++) {
      dots[i].classList.toggle('is-active', i === idx);
    }
  }, { capture: true, passive: true });

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.diesel-card-arrow');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();
    var media = btn.closest('.card__media');
    if (!media) return;
    dieselLoadCardImages(media);
    var track = media.querySelector('.diesel-gallery__track');
    if (!track) return;
    var count = track.querySelectorAll('.diesel-gallery__img').length;
    if (count < 2) return;
    var current = parseInt(track.style.getPropertyValue('--gindex'), 10) || 0;
    var dir = btn.classList.contains('diesel-card-arrow--next') ? 1 : -1;
    var next = (current + dir + count) % count;
    track.style.setProperty('--gindex', next);
  });
})();
